import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "icon/action/delete_24px",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "icon/action/delete_24px_2",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.6665 3H9.6665L8.6665 4H5.1665V6H19.1665V4H15.6665L14.6665 3ZM16.1665 9V19H8.1665V9H16.1665ZM6.1665 7H18.1665V19C18.1665 20.1 17.2665 21 16.1665 21H8.1665C7.0665 21 6.1665 20.1 6.1665 19V7Z",
				fill: "#EB5757"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0",
				"mask-type": "alpha",
				maskUnits: "userSpaceOnUse",
				x: 5,
				y: 3,
				width: 15,
				height: 18,
				children: /* @__PURE__ */ _jsx("path", {
					id: "icon/action/delete_24px_3",
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M14.6665 3H9.6665L8.6665 4H5.1665V6H19.1665V4H15.6665L14.6665 3ZM16.1665 9V19H8.1665V9H16.1665ZM6.1665 7H18.1665V19C18.1665 20.1 17.2665 21 16.1665 21H8.1665C7.0665 21 6.1665 20.1 6.1665 19V7Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", { mask: "url(#mask0)" })
		]
	})]
});
const ForwardRef = forwardRef(SvgTrash);
export default ForwardRef;
